var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data.yesNo
    ? _c("SelectedItems", {
        attrs: {
          "characteristic-items": _vm.meta.geo,
          "characteristic-type": _vm.meta.geoType,
          selected: _vm.data.geo,
          "none-info": "Ich würde überall hin übersiedeln"
        }
      })
    : _c("div", { staticClass: "sub-values inline" }, [
        _c("div", { staticClass: "sub-value" }, [
          _c("div", { staticClass: "label" }, [_vm._v("Nein")])
        ])
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }